import Layout from "components/Layout";
import React from "react";
import LibraryEditForm from "./components/LibraryEditForm";

function AdminLibraryEditPage() {
  return (
    <Layout title="라이브러리 수정/삭제">
      <LibraryEditForm />
    </Layout>
  );
}

export default AdminLibraryEditPage;
